import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (locale, i) => {
      return (_openBlock(), _createElementBlock("img", {
        key: `locale-${i}`,
        onClick: ($event: any) => (_ctx.changeLocale(locale)),
        src: require('@/assets/images/'+locale+'_flag.png'),
        class: _normalizeClass([{ 'flag_selectd': (locale === _ctx.activeId) },'flag_select','flag_'+locale])
      }, null, 10, _hoisted_1))
    }), 128))
  ]))
}